<template>
  <div>
    <header-tool-bar @toggleDrawer="drawer = !drawer"></header-tool-bar>
    <sidebar :drawer="drawer" />
    <v-content class="page-content">
      <slot />
    </v-content>
    <loader></loader>
    <error-popup></error-popup>
    <v-snackbar
      v-model="$store.state.core.snackbar.status"
      :color="$store.state.core.snackbar.color"
      :timeout="$store.state.core.snackbar.timeout"
      :multi-line="$store.state.core.snackbar.multiLine"
      :auto-height="true"
      right
    >
      <div v-html="$store.state.core.snackbar.text" />
      <v-btn dark flat @click="$store.state.core.snackbar.status = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import errorPopup from "../components/common/errorPopup";
import headerToolBar from "../components/common/headerToolBar";
import loader from "../components/common/loader";
import sidebar from "../components/common/sidebar";
export default {
  name: "Default",
  components: {
    errorPopup,
    sidebar,
    headerToolBar,
    loader,
  },
  data() {
    return {
      drawer: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // Get The Current Bot
      const botId = localStorage.getItem("botId");
      if (botId) this.$store.dispatch("setBotId", botId);
      const botTitle = localStorage.getItem("botTitle");
      if (botTitle) this.$store.dispatch("setBotTitle", botTitle);
      // Get All Bots
      const lsBots = localStorage.getItem("allBots");
      if (lsBots) {
        this.$store.dispatch("setAllBots", JSON.parse(lsBots));
      }
    },
  },
};
</script>

<style>
.v-snack--bottom {
  bottom: 10px;
}
.v-snack__wrapper {
  border-radius: 8px;
}
</style>
